export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

export const API_PATHS = {
  auth: {
    signin: '/api/auth/signin',
  },
  coPilot: {
    send: '/api/copilot/chat',
  },
  threads: {
    update: '/api/threads',
    createWithMessages: '/api/threads/create-with-messages',
    bulkUpdate: '/api/threads/messages/bulk-update',
    delete: (threadId: string) => `/api/threads/${threadId}`,
  },
  wahaSessions: {
    create: '/api/waha-sessions/session',
    get: '/api/waha-sessions/session',
    update: '/api/waha-sessions/session',
    delete: '/api/waha-sessions/session',
    start: '/api/waha-sessions/session/start',
    stop: '/api/waha-sessions/session/stop',
    restart: '/api/waha-sessions/session/restart',
    logout: '/api/waha-sessions/session/logout',
    qr: '/api/waha-sessions/session/qr',
    requestCode: '/api/waha-sessions/session/request-code',
    events: '/api/waha-sessions/events',
    status: '/api/waha-sessions/session/status',
    deletionStatus: (jobId: string) =>
      `/api/waha-sessions/deletion-status/${jobId}`,
  },
  notes: {
    create: '/api/notes',
    get: '/api/notes',
    update: (noteId: string) => `/api/notes/${noteId}`,
    delete: (noteId: string) => `/api/notes/${noteId}`,
  },
};
